var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1841 0.666064L11 0.499756L3.81592 0.666064C2.36417 0.695565 1.13342 1.74209 0.870936 3.17022C0.28407 6.36331 0.284069 9.63662 0.870936 12.8297C1.13342 14.2578 2.36416 15.3044 3.81592 15.3339L11 15.5002L18.1841 15.3339C19.6359 15.3044 20.8666 14.2578 21.1291 12.8297C21.716 9.63662 21.716 6.36331 21.1291 3.17022C20.8666 1.74209 19.6359 0.695565 18.1841 0.666064ZM20 6.99994C20 7.55222 19.5523 7.99994 19 7.99994H3C2.44772 7.99994 2 7.55222 2 6.99994C2 6.44765 2.44772 5.99994 3 5.99994H19C19.5523 5.99994 20 6.44765 20 6.99994Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.2a95c267003657b4acbb73b79f966ecc.svg";
export { ForwardRef as ReactComponent };